import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontMerriweather, fontRoboto, fontRobotoCondensed } from "shared/lib/styles";

import { SignUpButton } from "scmp-app/components/newsletter/sign-up-button";

import IconClock from "./icon-clock.svg";

export const StyledIconClock = styled(IconClock)`
  inline-size: 18px;
  block-size: 18px;
  margin: 3px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: flex-start;
  align-self: stretch;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Name = styled.div`
  color: #000000;
  font-weight: 400;
  font-size: 36px;
  font-family: ${fontMerriweather};
  font-style: normal;
  line-height: normal;
  font-feature-settings:
    "liga" off,
    "clig" off;
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
`;

export const HeadingText = styled.div`
  color: #000000;
  font-weight: 400;
  font-size: 28px;
  font-family: ${fontMerriweather};
  font-style: normal;
  line-height: normal;
  font-feature-settings:
    "liga" off,
    "clig" off;
  span {
    color: #4585ff;
  }
`;

export const Summary = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  color: #000000;
  font-weight: 500;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: normal;
  text-transform: uppercase;
  font-feature-settings:
    "liga" off,
    "clig" off;
`;

export const Description = styled.div`
  color: #000000;
  font-weight: 400;
  font-size: 16px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: 130%; /* 20.8px */
  font-feature-settings:
    "liga" off,
    "clig" off;
`;

export const StyledSignUpButton = styled(SignUpButton)`
  inline-size: 140px;
`;

export const MyNewsButton = styled(BaseLink)`
  inline-size: 140px;
  max-inline-size: 140px;
  padding-block: 8px;
  padding-inline: 12px;

  color: #ffffff;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: normal;
  text-align: center;
  text-transform: uppercase;

  border-radius: 2px;

  background: #4585ff;
`;

export const SignUpButtonContainer = styled.div``;

export const Footer = styled.div`
  padding-block: 20px;

  color: #000000;
  font-weight: 400;
  font-size: 16px;
  font-family: Roboto;
  font-style: normal;
  line-height: 130%; /* 20.8px */

  border-block: 1px solid rgba(0, 0, 0, 0.2);
  font-feature-settings:
    "liga" off,
    "clig" off;

  span {
    color: #000000;
    font-weight: 700;
    font-size: 16px;
    font-family: ${fontRoboto};
    font-style: normal;
    line-height: 130%;
    font-feature-settings:
      "liga" off,
      "clig" off;
  }
`;

export const GetToKnowMore = styled.a`
  display: inline;

  color: #4585ff;
  font-weight: 400;
  font-size: 16px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: 130%;

  cursor: pointer;
  font-feature-settings:
    "liga" off,
    "clig" off;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
`;
